export class PlayClassProgress {
  maxStepId = -1;
  total = 0;

  constructor(maxStepId: number, progress: number) {
    this.maxStepId = maxStepId;
    this.total = progress;
  }

  get displayValue(): string {
    return `${Math.round(this.total * 100)}%`;
  }

  get isFinished(): boolean {
    return this.total === 1;
  }
}
